import { gql } from '@apollo/client';

export const fetchWhatsAppAccountsQuery = gql`
  query FetchWhatsAppAccounts {
    getWhatsAppMetaConfigValues {
      appId
      configId
      euSolutionId
      usSolutionId
    }
  }
`;
